import React, { useState } from 'react';
import ImageModal from './ImageModal';

interface Props {
  images: string[];
}

function ImageGallery({ images }: Props) {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <div>
      <div className="flex gap-4 flex-wrap">
        {images.map((img, idx) => (
          <button
            key={img} // Use filename, not index
            onClick={() => setSelectedImage(img)}
            type="button" // Avoid ESLint warning
            className="p-0 border-0 bg-transparent"
            aria-label={`View full image ${idx + 1}`}
          >
            <img
              src={img}
              alt={`Pallet ${idx + 1}`}
              style={{
                width: '8rem', height: '8rem', objectFit: 'cover', borderRadius: '0.5rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', cursor: 'pointer',
              }}
            />
          </button>
        ))}
      </div>
      {selectedImage && (
        <ImageModal imageSrc={selectedImage} onClose={() => setSelectedImage(null)} />
      )}
    </div>
  );
}

export default ImageGallery;
